
export const types = {
    // Auth
    login: '[Auth] Login',
    logout: '[Auth] Logout',
    isLogged: '[Auth] Is logged?',
}
